import { useCallback, useEffect, useState } from "react";

export const useScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);

  const checkScroll = useCallback(() => {
    setShowButton(window.pageYOffset > 300);
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, [checkScroll]);

  return { showScrollButton: showButton, scrollToTop };
};
